import React, { FC } from 'react';
import { FlexGrid, FlexGridColumn, ModalHeader } from '@clearcover/atlas';

import styles from './FormModalHeader.module.css';

export const FormModalHeader: FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ModalHeader>
      <FlexGrid>
        <FlexGridColumn
          mobile={8}
          mobileOffset={2}
          className={styles.modalHeader}
        >
          {children}
        </FlexGridColumn>
      </FlexGrid>
    </ModalHeader>
  );
};

FormModalHeader.displayName = 'FormModalHeader';
